module.exports = __webpack_public_path__ + "static/media/nisai.fc7f6473.png";